import { createSelector } from 'reselect';
import produce from 'immer';
import { selectCurrentCrewId } from './crews-selectors';

export const selectTemplates = (state) => state.bo.templates.templates || produce([], () => {});

export const selectCrewTemplates = createSelector(selectTemplates, selectCurrentCrewId, (template, crewId) =>
  template.filter((crew) => crew.crewId === crewId)
);
